import BookSecurelyBanner from './banners/BookSecurelyBanner';
import SelectBanner from './banners/SelectBanner';
import LongTermBanner from './banners/LongTermBanner';
import ValuePropositionBanner from './banners/ValuePropositionBanner/ValuePropositionBanner';

const BOOK_SECURELY_BANNER = {
  name: 'book-securely',
  isActive: () => false,
  component: BookSecurelyBanner,
  position: 3
};

const SELECT_BANNER = {
  name: 'select',
  isActive: () => false,
  component: SelectBanner,
  position: 3
};

const LONG_TERM_BANNER = {
  name: 'longTerm',
  isActive: () => false,
  component: LongTermBanner,
  position: 2
};

const VALUE_PROPOSITION_BANNER = {
  name: 'value-proposition',
  isActive: ({ showValuePropositionBanner }) => showValuePropositionBanner,
  component: ValuePropositionBanner,
  position: 4,
  cookieExpiration: 60 * 60 * 24 * 15 // 15 days in seconds
};

const BANNERS = [
  SELECT_BANNER,
  BOOK_SECURELY_BANNER,
  LONG_TERM_BANNER,
  VALUE_PROPOSITION_BANNER
];

export const getActiveBanners = (config = {}) =>
  BANNERS.filter(banner => banner.isActive(config));

export const getNumberActiveBanners = (config = {}) =>
  getActiveBanners(config).length;

export default {
  getActiveBanners,
  getNumberActiveBanners
};
